<template>
  <div>
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <div class="text-center">
          <h3 class="mb-0">
            Ads
          </h3>
          <p>
            You can turn on monetization for your channel and set up the frequency of ad insertion
          </p>
        </div>
      </v-col>

      <v-col
        cols="12"
        md="12"
      >
        <base-card class="">
          <v-card-text class="pa-4">
            <div class="d-flex justify-space-between">
              <div class="pr-4">
                <h5 class="text-18 ">
                  Dynamic ads
                </h5>
                <p class="">
                  Configure ad settings
                </p>
              </div>
            </div>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex">
                  <v-img
                    max-width="350"
                    max-height="35"
                    class=" mr-4"
                    src="https://sotalcloud.blob.core.windows.net/publicstorage/playout/layout_advertising.png"
                    alt=""
                  />
                  <p class="font-weight-medium text-h5 mb-0">
                    Advertising
                  </p>
                </div>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <div
                  v-if="channel.ads.adBlockDuration > 0"
                  class="d-flex"
                >
                  <v-icon
                    color="success"
                    class="mr-3"
                  >
                    mdi-check-circle
                  </v-icon>
                  <p class="font-weight-medium mb-0">
                    On
                  </p>
                </div>
                <div
                  v-else
                  class="d-flex"
                >
                  <v-icon
                    color="secondary"
                    class="mr-3"
                  >
                    mdi-minus-circle
                  </v-icon>
                  <p class="font-weight-medium mb-0">
                    Off
                  </p>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex">
                  <v-img
                    max-width="350"
                    max-height="35"
                    class="mr-4"
                    src="@/assets/images/in_content_advertising.png"
                    alt=""
                  />
                  <p class="font-weight-medium text-h5 mb-0">
                    In-content advertising
                  </p>
                </div>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <div
                  v-if="channel.ads.inContentAdvertising"
                  class="d-flex"
                >
                  <v-icon
                    color="success"
                    class="mr-3"
                  >
                    mdi-check-circle
                  </v-icon>
                  <p class="font-weight-medium mb-0">
                    On
                  </p>
                </div>
                <div
                  v-else
                  class="d-flex"
                >
                  <v-icon
                    color="secondary"
                    class="mr-3"
                  >
                    mdi-minus-circle
                  </v-icon>
                  <p class="font-weight-medium mb-0">
                    Off
                  </p>
                </div>
              </v-col>
            </v-row>
            <v-expansion-panels
              v-if="channel.ads.adBlockDuration > 0"
              class="my-4"
            >
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div class="d-flex flex-wrap align-center">
                    <div
                      style="flex: 1 1 0;"
                      class="d-flex align-center flex-wrap"
                    >
                      <v-icon
                        color="primary"
                        size="40"
                        class="mr-2"
                      >
                        mdi-arrow-expand-horizontal
                      </v-icon>
                      <p class="ma-0">
                        Minimum interval between ads
                      </p>
                    </div>
                    <div
                      class=""
                      style="flex: 1 1 0;"
                    >
                      {{ channel.ads.minInterval % 60 === 0 ? channel.ads.minInterval/60 : (channel.ads.minInterval/60).toFixed(1) }} min
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  Autosheduler will insert ads no more often than the specified time interval
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div class="d-flex flex-wrap align-center">
                    <div
                      style="flex: 1 1 0;"
                      class="d-flex align-center flex-wrap"
                    >
                      <v-icon
                        color="black"
                        size="40"
                        class="mr-2"
                      >
                        mdi-clock
                      </v-icon>
                      <p class="ma-0">
                        Ad-block duration
                      </p>
                    </div>
                    <div
                      class=""
                      style="flex: 1 1 0;"
                    >
                      {{ channel.ads.adBlockDuration % 60 === 0 ? channel.ads.adBlockDuration/60 : (channel.ads.adBlockDuration/60).toFixed(1) }} min
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  In the case of inserting ads into a video, the overall duration of the program will be extended by the length of the advertisement
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel v-if="channel.ads.inContentAdvertising">
                <v-expansion-panel-header>
                  <div class="d-flex flex-wrap align-center">
                    <div
                      style="flex: 1 1 0;"
                      class="d-flex align-center flex-wrap"
                    >
                      <v-icon
                        color="primary"
                        size="40"
                        class="mr-2"
                      >
                        mdi-block-helper
                      </v-icon>
                      <p class="ma-0">
                        Asset safe zone
                      </p>
                    </div>
                    <div
                      class=""
                      style="flex: 1 1 0;"
                    >
                      Do not show ads in the first
                      <b>{{ channel.ads.programSafeZoneLeft % 60 === 0 ? channel.ads.programSafeZoneLeft/60 : (channel.ads.programSafeZoneLeft/60).toFixed(1) }}</b>
                      min and the last
                      <b>{{ channel.ads.programSafeZoneRight % 60 === 0 ? channel.ads.programSafeZoneRight/60 : (channel.ads.programSafeZoneRight/60).toFixed(1) }}</b>
                      min of a program
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content />
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
          <v-card-actions
            class="primary--text grey lighten-5 py-4 text--pointer"
            @click="openEditForm()"
          >
            Manage ads
          </v-card-actions>
        </base-card>
      </v-col>
      <v-col
        cols="12"
        md="12"
      >
        <base-card
          v-if="chartOptions.xaxis.categories.length"
          class="h-full"
        >
          <v-card-title class="d-flex justify-space-between">
            <div class="mb-0 mr-4">
              <p class="card-title mb-0">
                Content Analytics
              </p>
            </div>
          </v-card-title>
          <v-card-text>
            <div
              id="basicArea-chart"
              style="min-height: 365px"
            >
              <apexchart
                type="bar"
                height="350"
                :options="chartOptions"
                :series="series"
              />
            </div>
          </v-card-text>
        </base-card>
      </v-col>
    </v-row>
    <!-- Edit Form  -->
    <v-dialog
      v-model="dialog"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Ads Settings</span>
        </v-card-title>
        <template v-if="!preSaveMsg">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-checkbox
                    v-model="advertising"
                    hide-details
                  >
                    <template v-slot:label>
                      <div>
                        Advertising
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-form ref="form1">
                <v-row v-if="advertising">
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      v-model="adBlockDuration"
                      label="Ad-block duration*"
                      type="number"
                      prepend-icon="mdi-clock"
                      hint="max 10 min"
                      suffix="min"
                      step="0.5"
                      :rules="rules.durationRules"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      v-model="minInterval"
                      label="Minimum interval between ads*"
                      suffix="min"
                      prepend-icon="mdi-arrow-expand-horizontal"
                      type="number"
                      hint="min 3 min, max 10 min"
                      :rules="rules.intervalRules"
                      step="0.5"
                    />
                  </v-col>
                </v-row>
              </v-form>
              <v-row v-if="advertising">
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-checkbox
                    v-model="inContentAdvertising"
                    hide-details
                  >
                    <template v-slot:label>
                      <div>
                        In-content advertising
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-form ref="form2">
                <v-row v-if="inContentAdvertising">
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      v-model="programSafeZoneLeft"
                      type="number"
                      label="Asset safe zone left*"
                      prepend-icon="mdi-arrow-collapse-right"
                      hint="max 10 min"
                      suffix="min"
                      step="0.5"
                      :rules="rules.zoneRules"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      v-model="programSafeZoneRight"
                      type="number"
                      suffix="min"
                      append-outer-icon="mdi-arrow-collapse-left"
                      label="Asset safe zone right*"
                      hint="max 10 min"
                      step="0.5"
                      :rules="rules.zoneRules"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue darken-1"
              text
              @click="closeDialog"
            >
              Close
            </v-btn>
            <v-btn
              color="primary"
              :disabled="loading || !isFormValid"
              @click="showPreSaveMsg()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </template>
        <template v-else>
          <v-card-text>
            <v-alert
              outlined
              type="warning"
              prominent
              border="left"
            >
              Apply changes
              <v-radio-group
                v-model="updateSchedule"
                column
              >
                <v-radio
                  label="to the current schedule (delete and create a new one from the current moment)"
                  color="red"
                  value="all"
                />
                <v-radio
                  label="only to the new schedule"
                  color="success"
                  value="new"
                />
              </v-radio-group>
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue darken-1"
              text
              @click="preSaveMsg = false"
            >
              Back
            </v-btn>
            <v-btn
              color="primary"
              :disabled="loading || !isFormValid"
              @click="saveEditForm()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import moment from 'moment-timezone'
  import { processChannel } from '@/store/converters'

  export default {
    data () {
      return {
        series: [
          {
            name: 'VOD',
            data: [],
          },
          {
            name: 'Ads',
            data: [],
          },
          {
            name: 'None',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
            stacked: true,
            stackType: '100%',
          },
          plotOptions: {
            bar: {
              horizontal: true,
              endingShape: 'rounded',
            },
          },
          colors: ['#1975d2', '#f48024', '#A5978B', '#90ee7e', '#13d8aa', '#33b2df', '#d4526e'],
          stroke: {
            width: 1,
            colors: ['#fff'],
          },
          xaxis: {
            categories: [],
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + ' min'
              },
            },
          },
          fill: {
            opacity: 1,
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 40,
          },
        },
        channel: {
          id: 0,
          ads: {},
        },
        dialog: false,
        advertising: true,
        inContentAdvertising: true,
        adBlockDuration: 2,
        minInterval: 7,
        programSafeZoneLeft: 3,
        programSafeZoneRight: 3,
        isSaving: false,
        preSaveMsg: false,
        updateSchedule: 'new',
        rules: {
          durationRules: [
            v => !!v || 'Duration is required',
            v => (v >= 0 && v <= 10) || 'Duration must be between 0 and 10 min',
          ],
          intervalRules: [
            v => !!v || 'Interval is required',
            v => (v >= 3 && v <= 10) || 'Interval must be between 3 and 10 min',
          ],
          zoneRules: [
            v => !!v || 'Value is required',
            v => (v >= 0 && v <= 10) || 'Value must be between 0 and 10 min',
          ],
        },
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      isFormValid () {
        if (this.advertising) {
          if (this.adBlockDuration < 0 || this.adBlockDuration > 10) {
            return false
          }
          if (this.minInterval < 3 || this.minInterval > 10) {
            return false
          }
        }
        if (this.adBlockDuration) {
          if (this.programSafeZoneLeft < 0 || this.programSafeZoneLeft > 10) {
            return false
          }
          if (this.programSafeZoneRight < 0 || this.programSafeZoneRight > 10) {
            return false
          }
        }
        return true
      },
    },
    created () {
      const channelId = this.$route.params.id
      this.channel.id = channelId

      this.getChannelInfo(channelId)
    },
    methods: {
      initSettings () {
        this.advertising = this.channel.ads.adBlockDuration > 0
        this.inContentAdvertising = this.channel.ads.inContentAdvertising
        if (this.channel.ads.adBlockDuration) {
          this.adBlockDuration = this.channel.ads.adBlockDuration % 60 === 0 ? this.channel.ads.adBlockDuration / 60 : Number((this.channel.ads.adBlockDuration / 60).toFixed(1))
        }
        if (this.channel.ads.minInterval) {
          this.minInterval = this.channel.ads.minInterval % 60 === 0 ? this.channel.ads.minInterval / 60 : Number((this.channel.ads.minInterval / 60).toFixed(1))
        }
        if (this.channel.ads.programSafeZoneLeft) {
          this.programSafeZoneLeft = this.channel.ads.programSafeZoneLeft % 60 === 0 ? this.channel.ads.programSafeZoneLeft / 60 : Number((this.channel.ads.programSafeZoneLeft / 60).toFixed(1))
        }
        if (this.channel.ads.programSafeZoneRight) {
          this.programSafeZoneRight = this.channel.ads.programSafeZoneRight % 60 === 0 ? this.channel.ads.programSafeZoneRight / 60 : Number((this.channel.ads.programSafeZoneRight / 60).toFixed(1))
        }
      },
      getChannelInfo (id) {
        this.$store.commit('setPageLoader')

        const args = {
          ids: id,
          expand: 'ads',
        }
        const channelReq = this.$store.dispatch('channels', args)

        return Promise.all([channelReq])
          .then((res) => {
            const channels = res[0]
            this.channel = processChannel(channels[0])
            this.initSettings()
            if (this.advertising) {
              this.getContentDistribution()
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      getContentDistribution () {
        this.$store.commit('setPageLoader')

        const args = {
          channelId: this.channel.id,
        }
        const contentDistribReq = this.$store.dispatch('contentDistribution', args)

        return Promise.all([contentDistribReq])
          .then((res) => {
            const distrib = res[0]
            if (distrib && distrib.length) {
              const xaxis = []
              const adData = []
              const vodData = []
              const emptySlotData = []
              for (let i = 0; i < distrib.length; i += 1) {
                const d = distrib[distrib.length - i - 1]
                xaxis.push(moment(d.date).utc().format('MMM D'))
                adData.push(Math.round(d.ad_sec / 60))
                if (i === 0) {
                  vodData.push(Math.round(d.vod_sec / 60))
                  emptySlotData.push(Math.round((24 * 3600 - d.vod_sec - d.ad_sec) / 60))
                } else {
                  vodData.push(Math.round((24 * 3600 - d.ad_sec) / 60))
                }
              }
              this.chartOptions = {
                ...this.chartOptions,
                ...{
                  xaxis: {
                    categories: xaxis,
                  },
              },
              }
              this.series[1].data = adData
              this.series[0].data = vodData
              this.series[2].data = emptySlotData
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      showPreSaveMsg () {
        this.preSaveMsg = true
      },
      openEditForm () {
        this.initSettings()
        this.dialog = true
      },
      adsToJson () {
        const processed = {
          in_content_advertising: false,
          ad_block_duration: 0,
          min_interval: 3 * 60,
          program_safe_zone_left: 0,
          program_safe_zone_right: 0,
        }
        if (!this.advertising) {
          return processed
        }
        processed.ad_block_duration = this.adBlockDuration * 60
        processed.min_interval = this.minInterval * 60
        if (this.inContentAdvertising) {
          processed.in_content_advertising = true
          processed.program_safe_zone_left = this.programSafeZoneLeft * 60
          processed.program_safe_zone_right = this.programSafeZoneRight * 60
        }
        return processed
      },
      saveEditForm () {
        if (!this.isFormValid) return
        this.isSaving = true

        this.$store.commit('setPageLoader')

        const requests = [
          this.$store.dispatch('setAds', {
            channelId: this.channel.id,
            ads: this.adsToJson(),
          }),
        ]
        if (this.updateSchedule === 'all') {
          requests.push(this.$store.dispatch('clearSchedule', { channel_id: this.channel.id }))
        }

        return Promise.all(requests)
          .then(() => {
            this.getChannelInfo(this.channel.id)
            this.$store.commit('showSnackbar', {
              text: 'New settings has been successfully saved',
              timeout: 3000,
              color: 'success',
            })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
            this.isSaving = false
            this.dialog = false
            this.preSaveMsg = false
          })
      },
      closeDialog () {
        this.dialog = false
      },
    },
  }
</script>

<style>
</style>
